export const handleError = (error: any) => {
  if (error.response && error.response.data) {
    console.log("Response Error: ", error.response.data.message);
    return alert(error.response.data.message);
  } else {
    if (error.code)
    console.log("Unexpected Error: ", error);
    return alert(error);
  }
}